var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.3335 10.8332H4.66683V14.1665H15.3335V10.8332H16.6668V14.1665C16.6668 14.9065 16.0735 15.4998 15.3335 15.4998H4.66683C3.9335 15.4998 3.3335 14.9065 3.3335 14.1665V10.8332ZM10.0002 12.8332L13.7002 9.19317L12.7535 8.25317L10.6668 10.3332V4.1665H9.3335V10.3332L7.2535 8.25317L6.30683 9.19984L10.0002 12.8332Z",
    fill: "#FBFBFB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons);
export default __webpack_public_path__ + "static/media/Icons.189ee647c782d80dd6d3466df9041d43.svg";
export { ForwardRef as ReactComponent };